export const ArrowSmallIcon = ({
  color = '#636F7E',
  transform = undefined,
}: {
  color?: string
  transform?: string
}) => {
  return (
    <svg
      style={{ transform, transition: 'transform 0.3s linear' }}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Chevron Icon">
        <path
          id="Icon"
          d="M9 18L15 12L9 6"
          stroke={color ? color : '#636F7E'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
